exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".compare-count[data-v-55232558] {\n  top: -4px;\n  right: 4px;\n  min-width: 16px;\n  min-height: 16px;\n  border-radius: 10px;\n}\n", ""]);

// exports
